import React from 'react'

import NavMenu from './NavMenu';
import NavHeader from './NavHeader';

function Header(props : any) {
	return (
		<>
			<NavHeader {...props} />
			<NavMenu {...props} />
		</>
	)
	
}

export default Header;
